import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=61153afb&scoped=true"
import script from "./Recuperar.vue?vue&type=script&lang=js"
export * from "./Recuperar.vue?vue&type=script&lang=js"
import style0 from "./Recuperar.vue?vue&type=style&index=0&id=61153afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61153afb",
  null
  
)

export default component.exports